export default {
  CREATE: 'PROMOTION/CREATE',
  DELETE: 'PROMOTION/DELETE',
  UPDATE: 'PROMOTION/UPDATE'
};
